(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    (function() {
    var drawer = document.getElementById('cart-drawer');
    var overlay = document.getElementById('cart-overlay');
    var closeBtn = document.getElementById('cart-drawer-close');
    window.CartDrawer = {
      _busy: false,
      _reqId: 0,
      open: function() {
        this.refresh();
        if (drawer) drawer.classList.add('is-open');
        if (overlay) overlay.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      },
      close: function() {
        if (drawer) drawer.classList.remove('is-open');
        if (overlay) overlay.classList.remove('is-open');
        document.body.style.overflow = '';
      },
      refresh: function() {
        var id = ++CartDrawer._reqId;
        fetch('/cart.js')
          .then(function(r) { return r.json(); })
          .then(function(cart) {
            if (id !== CartDrawer._reqId) return;
            CartDrawer._applyCart(cart);
          });
      },
      _applyCart: function(cart) {
        var self = this;
        this._fetchVariantCompareAtPrices(cart.items).then(function(variantToCompare) {
          self.renderItems(cart, variantToCompare);
          self.renderTotal(cart);
          self.updateBadge(cart);
          self.loadRecs(cart);
        });
      },
      _fetchVariantCompareAtPrices: function(items) {
        var handles = [];
        var seen = {};
        items.forEach(function(item) {
          if (item.handle && !seen[item.handle]) { seen[item.handle] = true; handles.push(item.handle); }
        });
        if (handles.length === 0) return Promise.resolve({});
        return Promise.all(handles.map(function(handle) {
          return fetch('/products/' + handle + '.js').then(function(r) { return r.json(); }).catch(function() { return { variants: [] }; });
        })).then(function(products) {
          var variantToCompare = {};
          products.forEach(function(product) {
            if (product.variants) {
              product.variants.forEach(function(v) {
                if (v.compare_at_price != null && v.compare_at_price > v.price) {
                  variantToCompare[v.id] = v.compare_at_price;
                }
              });
            }
          });
          return variantToCompare;
        });
      },
      renderItems: function(cart, variantToCompare) {
        variantToCompare = variantToCompare || {};
        var container = document.getElementById('cart-items');
        var emptyEl = document.getElementById('cart-empty');
        var footerEl = document.getElementById('cart-footer');
        if (!container) return;

        if (cart.items.length === 0) {
          container.innerHTML = '';
          if (emptyEl) emptyEl.style.display = '';
          if (footerEl) footerEl.style.display = 'none';
          return;
        }

        if (emptyEl) emptyEl.style.display = 'none';
        if (footerEl) footerEl.style.display = '';

        var html = '';
        cart.items.forEach(function(item) {
          var itemKey = item.key;
          var img = item.image ? item.image.replace(/(\.[^.]+)$/, '_160x$1') : '';
          var variantTitle = item.variant_title || '';
          var unitPrice = item.final_price != null ? item.final_price : item.price;
          var compareAt = item.compare_at_price != null ? item.compare_at_price : (variantToCompare[item.variant_id] != null ? variantToCompare[item.variant_id] : 0);
          if (compareAt === 0 && item.original_price != null && item.original_price > unitPrice) compareAt = item.original_price;
          var onSale = compareAt > 0 && compareAt > unitPrice;
          var salePercent = onSale ? Math.round((compareAt - unitPrice) / compareAt * 100) : 0;
          var priceFormatted = (item.final_line_price / 100).toLocaleString('en-LK', { style: 'currency', currency: cart.currency });
          var unitPriceFormatted = (unitPrice / 100).toLocaleString('en-LK', { style: 'currency', currency: cart.currency });
          var compareFormatted = onSale ? (compareAt / 100).toLocaleString('en-LK', { style: 'currency', currency: cart.currency }) : '';

          html += '<div class="cart-item" data-item-key="' + itemKey + '">';
          html += '<div class="cart-item__image">';
          var offLabel = (document.getElementById('cart-drawer') && document.getElementById('cart-drawer').getAttribute('data-off-label')) || 'off';
          if (onSale) html += '<span class="cart-item__badge">' + salePercent + '% ' + offLabel + '</span>';
          if (img) html += '<img src="' + img + '" alt="' + item.title + '" loading="lazy">';
          html += '</div>';
          html += '<div class="cart-item__details">';
          html += '<p class="cart-item__title">' + item.product_title + '</p>';
          if (variantTitle) html += '<p class="cart-item__variant">' + variantTitle + '</p>';
          html += '<button class="cart-item__remove" data-item-key="' + itemKey + '" aria-label="Remove">';
          html += '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M3 6h18"/><path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/></svg>';
          html += '</button>';
          html += '<div class="cart-item__bottom">';
          html += '<div class="cart-item__price-wrap">';
          if (onSale) html += '<s class="cart-item__compare-price">' + compareFormatted + '</s>';
          html += '<span class="cart-item__price">' + priceFormatted + '</span>';
          html += '</div>';
          html += '<div class="cart-item__qty">';
          html += '<button data-item-key="' + itemKey + '" data-qty="' + (item.quantity - 1) + '">−</button>';
          html += '<span class="cart-item__qty-value">' + item.quantity + '</span>';
          html += '<button data-item-key="' + itemKey + '" data-qty="' + (item.quantity + 1) + '">+</button>';
          html += '</div>';
          html += '</div></div></div>';
        });

        container.innerHTML = html;

        container.querySelectorAll('.cart-item__remove').forEach(function(btn) {
          btn.addEventListener('click', function() {
            CartDrawer.updateItem(this.dataset.itemKey, 0);
          });
        });

        container.querySelectorAll('.cart-item__qty button').forEach(function(btn) {
          btn.addEventListener('click', function() {
            CartDrawer.updateItem(this.dataset.itemKey, parseInt(this.dataset.qty));
          });
        });
      },
      renderTotal: function(cart) {
        var priceEl = document.getElementById('cart-total-price');
        if (priceEl) {
          priceEl.textContent = (cart.total_price / 100).toLocaleString('en-LK', { style: 'currency', currency: cart.currency });
        }
      },
      updateBadge: function(cart) {
        var badges = document.querySelectorAll('[data-cart-count]');
        badges.forEach(function(el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? '' : 'none';
        });
      },
      updateItem: function(itemKey, qty) {
        if (CartDrawer._busy) return;
        CartDrawer._busy = true;
        var id = ++CartDrawer._reqId;
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: String(itemKey), quantity: qty })
        })
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          cart.items = cart.items.filter(function(item) { return item.quantity > 0; });
          CartDrawer._busy = false;
          if (id !== CartDrawer._reqId) return;
          CartDrawer._applyCart(cart);
        })
        .catch(function() {
          CartDrawer._busy = false;
          CartDrawer.refresh();
        });
      },
      addItem: function(variantId, qty) {
        if (CartDrawer._busy) return;
        CartDrawer._busy = true;
        ++CartDrawer._reqId;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: qty || 1 })
        })
        .then(function(r) { return r.json(); })
        .then(function() {
          CartDrawer._busy = false;
          CartDrawer.open();
        })
        .catch(function() {
          CartDrawer._busy = false;
        });
      },
      loadRecs: function(cart) {
        var list = document.getElementById('cart-recs-list');
        var recsWrap = document.getElementById('cart-recs');
        if (!list || cart.items.length === 0) {
          if (recsWrap) recsWrap.style.display = 'none';
          return;
        }

        var productId = cart.items[0].product_id;
        fetch('/recommendations/products.json?product_id=' + productId + '&limit=10')
          .then(function(r) { return r.json(); })
          .then(function(data) {
            var products = data.products || [];
            if (products.length === 0) {
              if (recsWrap) recsWrap.style.display = 'none';
              return;
            }
            if (recsWrap) recsWrap.style.display = '';

            var cartIds = cart.items.map(function(i) { return i.product_id; });
            products = products.filter(function(p) { return cartIds.indexOf(p.id) === -1; }).slice(0, 6);

            var html = '';
            products.forEach(function(p) {
              var productUrl = p.url || ('/products/' + (p.handle || ''));
              var img = p.featured_image ? p.featured_image.replace(/(\.[^.]+)$/, '_400x$1') : '';
              var title = (p.title || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
              var priceStr = (p.price / 100).toLocaleString('en-LK', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
              var price = 'LKR ' + priceStr;
              var comparePrice = p.compare_at_price && p.compare_at_price > p.price
                ? '<s>LKR ' + (p.compare_at_price / 100).toLocaleString('en-LK', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '</s> '
                : '';
              var variantId = p.variants && p.variants[0] ? p.variants[0].id : '';

              html += '<div class="cart-rec">';
              html += '<div class="cart-rec__media">';
              html += '<a class="cart-rec__link" href="' + productUrl + '">';
              html += '<div class="cart-rec__image"><img src="' + img + '" alt="" loading="lazy"></div>';
              html += '</a>';
              html += '<button type="button" class="cart-rec__add" data-variant-id="' + variantId + '" aria-label="Add to cart">';
              html += '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>';
              html += '</button>';
              html += '</div>';
              html += '<div class="cart-rec__info">';
              html += '<p class="cart-rec__title">' + title + '</p>';
              html += '<p class="cart-rec__price">' + comparePrice + price + '</p>';
              html += '</div>';
              html += '</div>';
            });

            list.innerHTML = html;

            list.querySelectorAll('.cart-rec__add').forEach(function(btn) {
              btn.addEventListener('click', function(e) {
                e.preventDefault();
                CartDrawer.addItem(parseInt(this.dataset.variantId), 1);
              });
            });

            setupCartRecsScroll();
          });
      }
    };

    function setupCartRecsScroll() {
      var list = document.getElementById('cart-recs-list');
      var prevBtn = document.querySelector('.cart-drawer__recs-arrow--prev');
      var nextBtn = document.querySelector('.cart-drawer__recs-arrow--next');
      if (!list || !prevBtn || !nextBtn) return;
      var cardCount = list.querySelectorAll('.cart-rec').length;
      if (cardCount <= 2) {
        prevBtn.disabled = true;
        nextBtn.disabled = true;
        return;
      }
      function getScrollAmount() {
        var first = list.querySelector('.cart-rec');
        if (!first) return list.offsetWidth * 0.5;
        var gap = parseFloat(getComputedStyle(list).gap) || 8;
        return first.offsetWidth + gap;
      }
      function updateArrows() {
        prevBtn.disabled = list.scrollLeft <= 2;
        nextBtn.disabled = list.scrollLeft + list.offsetWidth >= list.scrollWidth - 2;
      }
      prevBtn.onclick = function() { list.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' }); };
      nextBtn.onclick = function() { list.scrollBy({ left: getScrollAmount(), behavior: 'smooth' }); };
      list.addEventListener('scroll', updateArrows, { passive: true });
      updateArrows();
    }

    if (closeBtn) closeBtn.addEventListener('click', function() { CartDrawer.close(); });
    if (overlay) overlay.addEventListener('click', function() { CartDrawer.close(); });

    document.querySelectorAll('[data-cart-trigger]').forEach(function(el) {
      el.addEventListener('click', function(e) {
        e.preventDefault();
        CartDrawer.open();
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["inapp-browser-escape"] && !Shopify.designMode) return;
  try {
    (function() {
    var ua = navigator.userAgent || '';
    var isIOS = /iPad|iPhone|iPod/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    if (!isIOS) return;

    var isInstagram = /Instagram/i.test(ua);
    var isFacebook = /FBAN|FBAV|FBIOS/i.test(ua);
    if (!isInstagram && !isFacebook) return;

    var banner = document.getElementById('inapp-escape');
    if (!banner) return;

    var dismissKey = 'inapp_escape_dismissed_v1';
    try {
      if (window.sessionStorage && sessionStorage.getItem(dismissKey) === '1') return;
    } catch (e) {}

    // Preserve full URL including UTMs, fbclid, variant, etc.
    var fullUrl = String(window.location.href);

    banner.hidden = false;

    function copyText(text) {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        return navigator.clipboard.writeText(text);
      }
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.position = 'absolute';
      ta.style.left = '-9999px';
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
      return Promise.resolve();
    }

    var copyBtn = document.getElementById('inapp-escape-copy');
    var shareBtn = document.getElementById('inapp-escape-share');

    if (copyBtn) {
      var originalCopyLabel = copyBtn.textContent;
      copyBtn.addEventListener('click', function() {
        copyText(fullUrl).then(function() {
          copyBtn.textContent = copyBtn.getAttribute('data-copied-label') || 'Copied';
          setTimeout(function() { copyBtn.textContent = originalCopyLabel; }, 1500);
        });
      });
    }

    if (shareBtn) {
      if (!navigator.share) {
        shareBtn.style.display = 'none';
      } else {
        shareBtn.addEventListener('click', function() {
          navigator.share({ url: fullUrl }).catch(function() {});
        });
      }
    }

    // Allow users to dismiss by tapping outside buttons (kept simple / non-invasive).
    banner.addEventListener('click', function(e) {
      if (e.target && (e.target.id === 'inapp-escape-copy' || e.target.id === 'inapp-escape-share')) return;
      try { if (window.sessionStorage) sessionStorage.setItem(dismissKey, '1'); } catch (err) {}
      banner.hidden = true;
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
